import React from 'react';
import './footer.css';

export default function Footer() {
  return (
    <section className="container p-3">
        <footer>
            <div className="nav border-bottom justify-content-center">
                <ul className="nav footer--nav">
                    <li className="nav-item"><a href="#Cover" className="nav-link px-3 text-muted">Home</a></li>
                    <li className="nav-item"><a href="#About" className="nav-link px-3 text-muted">About</a></li>
                    <li className="nav-item"><a href="#Specializations" className="nav-link px-3 text-muted">Specializations</a></li>
                    <li className="nav-item"><a href="#Projects" className="nav-link px-3 text-muted">Projects</a></li>
                    <li className="nav-item"><a href="#Contact" className="nav-link px-3 text-muted">Contacts</a></li>
                </ul>
            </div>
            <p className="text-center pt-4 text-muted">&copy; 2022, David Piredda</p>
        </footer>
    </section>
  )
}
